import {
  InputTypes,
  PayLoadValue,
  PreprocessorTypes,
} from '@cashier/cashier-model';

import { PreProcessorConverter } from './preProcessorConverter';

export const encryptPreProcessedValue = (
  value: PayLoadValue,
  context: {
    inputType: InputTypes;
    preprocessorType?: PreprocessorTypes;
  },
): PayLoadValue => {
  const { inputType, preprocessorType } = context;

  if (
    !value &&
    inputType !== InputTypes.Select &&
    inputType !== InputTypes.Hidden
  ) {
    return value;
  }

  if (typeof value !== 'string') {
    return value;
  }

  const trimmedValue = value.trim();

  return preprocessorType
    ? PreProcessorConverter.convertValue(trimmedValue, preprocessorType)
    : trimmedValue;
};
